// TO DO: Delete these and import icon components from the design system
// (The Small and Large icons will be added to the design system after v23)
export const SmallCardIcon = () => {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <rect
        stroke="#141414"
        strokeWidth="1.5"
        x="3.75"
        y="3.75"
        width="6.5"
        height="6.5"
        fill="none"
      ></rect>
      <rect
        stroke="#141414"
        strokeWidth="1.5"
        x="3.75"
        y="13.75"
        width="6.5"
        height="6.5"
        fill="none"
      ></rect>
      <rect
        stroke="#141414"
        strokeWidth="1.5"
        x="13.75"
        y="13.75"
        width="6.5"
        height="6.5"
        fill="none"
      ></rect>
      <rect
        stroke="#141414"
        strokeWidth="1.5"
        x="13.75"
        y="3.75"
        width="6.5"
        height="6.5"
        fill="none"
      ></rect>
    </svg>
  );
};

export const LargeCardIcon = () => {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24">
      <rect
        stroke="#141414"
        strokeWidth="1.5"
        x="2.75"
        y="3.75"
        width="7.5"
        height="16.5"
        fill="none"
      ></rect>
      <rect
        stroke="#141414"
        strokeWidth="1.5"
        x="13.75"
        y="3.75"
        width="7.5"
        height="16.5"
        fill="none"
      ></rect>
    </svg>
  );
};
